import { BaseModule } from "./base.module";

export class NotificationModule {
    initialize() {
        this.notificationElements = document.querySelectorAll('.notification');

        this.notificationElements.forEach((element) => new Notification(element));
    }
}

class NotificationCountdown extends BaseModule {
    constructor(notificationElement) {
        super();
        this.notificationElement = notificationElement;
        this.root = this.notificationElement.querySelector('.notification-countdown');
        if (!this.root) return;

        const targetString = this.root.getAttribute('data-countdown');
        this.target = this.parseLocalDateTime(targetString);
        if (!this.target) return;

        this.days = this.root.querySelector('.notification-countdown__days');
        this.daysNum = this.root.querySelector('.notification-countdown__days-number');
        this.daysLabel = this.root.querySelector('.notification-countdown__days-label');
        this.hours = this.root.querySelector('.notification-countdown__hours');
        this.hoursNum = this.root.querySelector('.notification-countdown__hours-number');
        this.hoursLabel = this.root.querySelector('.notification-countdown__hours-label');
        this.minutes = this.root.querySelector('.notification-countdown__minutes');
        this.minutesNum = this.root.querySelector('.notification-countdown__minutes-number');
        this.minutesLabel = this.root.querySelector('.notification-countdown__minutes-label');
        this.seconds = this.root.querySelector('.notification-countdown__seconds');
        this.secondsNum = this.root.querySelector('.notification-countdown__seconds-number');
        this.secondsLabel = this.root.querySelector('.notification-countdown__seconds-label');

        this.daysLabelTexts = this.readLabels('days');
        this.hoursLabelTexts = this.readLabels('hours');
        this.minutesLabelTexts = this.readLabels('minutes');
        this.secondsLabelTexts = this.readLabels('seconds');
    }

    readLabels(unit) {
        const container = this.root.querySelector(`.notification-countdown__${unit}-labels`);
        const singular = container?.querySelector(`.notification-countdown__${unit}-label--singular`)?.textContent?.trim();
        const plural = container?.querySelector(`.notification-countdown__${unit}-label--plural`)?.textContent?.trim();

        return {
            singular: singular,
            plural: plural,
        };
    }

    parseLocalDateTime(dateTimeString) {
        if (!dateTimeString) return null;
        const date = new Date(dateTimeString.trim().replace(' ', 'T'));
        return Number.isNaN(date.getTime()) ? null : date;
    }

    initialize() {
        if (!this.root || !this.target) return;
        this.update();
        this.intervalId = setInterval(this.update.bind(this), 1000);
    }

    update() {
        const now = new Date();
        const remainingRaw = Math.floor((this.target.getTime() - now.getTime()) / 1000);

        if (remainingRaw <= 0) {
            // Swap message text to the post-countdown text if provided
            const textEl = this.notificationElement.querySelector('.notification__text');
            const afterText = textEl?.getAttribute('data-after-text');
            if (afterText && textEl) {
                textEl.textContent = afterText;
            }

            // Reveal link if it was hidden until after countdown
            const linkEl = this.notificationElement.querySelector('.notification__link[hidden]');
            if (linkEl) {
                linkEl.removeAttribute('hidden');
                linkEl.removeAttribute('aria-hidden');
            }

            if (this.root) this.root.style.display = 'none';
            this.destroy();
            return;
        }

        let remaining = remainingRaw;

        const days = Math.floor(remaining / 86400);
        remaining -= days * 86400;
        const hours = Math.floor(remaining / 3600);
        remaining -= hours * 3600;
        const minutes = Math.floor(remaining / 60);
        remaining -= minutes * 60;
        const seconds = remaining;

        if (this.daysNum) this.daysNum.textContent = String(days);
        if (this.hoursNum) this.hoursNum.textContent = String(hours);
        if (this.minutesNum) this.minutesNum.textContent = String(minutes);
        if (this.secondsNum) this.secondsNum.textContent = String(seconds);

        if (this.daysLabel) this.daysLabel.textContent = days === 1 ? this.daysLabelTexts.singular : this.daysLabelTexts.plural;
        if (this.hoursLabel) this.hoursLabel.textContent = hours === 1 ? this.hoursLabelTexts.singular : this.hoursLabelTexts.plural;
        if (this.minutesLabel) this.minutesLabel.textContent = minutes === 1 ? this.minutesLabelTexts.singular : this.minutesLabelTexts.plural;
        if (this.secondsLabel) this.secondsLabel.textContent = seconds === 1 ? this.secondsLabelTexts.singular : this.secondsLabelTexts.plural;

        if (this.days) this.days.style.display = days === 0 ? 'none' : '';
        if (this.hours) this.hours.style.display = (days === 0 && hours === 0) ? 'none' : '';
        if (this.minutes) this.minutes.style.display = (days === 0 && hours === 0 && minutes === 0) ? 'none' : '';
        if (this.seconds) this.seconds.style.display = '';

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
            this.destroy();
        }
    }

    destroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

class Notification extends BaseModule {
    constructor(notificationElement) {
        super();
        this.notificationElement = notificationElement;

        if (!this.closeButton) {
            return;
        }

        this.initialize();
    }

    get closeButton() {
        return this.notificationElement.querySelector('.notification__close');
    }

    initialize() {
        this.closeButton.addEventListener('click', this.close.bind(this));
        if (sessionStorage.getItem('hide-top-notification')) {
            return;
        }

        this.notificationElement.classList.remove('notification--closed');

        this.countdown = new NotificationCountdown(this.notificationElement);
        this.countdown.initialize();
    }

    close() {
        sessionStorage.setItem('hide-top-notification', true);
        this.triggerEventOnElement('notification-closed', document.documentElement);
        this.notificationElement.classList.add('notification--closed');

        // Stop countdown timer if it is running
        if (this.countdown && typeof this.countdown.destroy === 'function') {
            this.countdown.destroy();
        }
    }
}
